(function () {
  if (window.__stickeredNativeBannerSizeReady) return;
  window.__stickeredNativeBannerSizeReady = true;

  function findSection(node) {
    return (node && node.closest && node.closest('[id^="ProductSection-"]')) ||
      document.querySelector('[id^="ProductSection-"]');
  }

  function findNativeSizeWrapper(section) {
    if (!section) return null;

    var selects = Array.prototype.slice.call(section.querySelectorAll('.single-option-selector'));

    var sizeSelect = selects.find(function (select) {
      return String(select.getAttribute('data-name') || '').toLowerCase() === 'size';
    }) || selects[0];

    if (!sizeSelect) return null;

    return sizeSelect.closest('.selector-wrapper') || sizeSelect.parentElement;
  }

  function clean(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/\s+/g, ' ')
      .trim();
  }

  function readVariantData(section) {
    var dataEl = section && section.querySelector('[id^="StickeredBannerVariantData-"]');
    if (!dataEl) dataEl = document.querySelector('[id^="StickeredBannerVariantData-"]');
    if (!dataEl) return [];

    try {
      return JSON.parse(dataEl.textContent || '[]');
    } catch (error) {
      return [];
    }
  }

  function formatMoney(cents) {
    return '$' + (Number(cents || 0) / 100).toFixed(2);
  }

  function findVariantForSelect(section, select) {
    if (!section || !select) return null;

    var selectedTitle = clean(select.value);
    var variants = readVariantData(section);

    return variants.find(function (variant) {
      return clean(variant.title) === selectedTitle;
    }) || null;
  }

  function updateAfterpayText(section, priceCents) {
    if (!section) return;

    var paymentAmount = formatMoney(Math.round(Number(priceCents || 0) / 4));
    var walker = document.createTreeWalker(section, NodeFilter.SHOW_TEXT);
    var nodes = [];

    while (walker.nextNode()) {
      if (walker.currentNode.nodeValue.indexOf('interest-free payments of') !== -1) {
        nodes.push(walker.currentNode);
      }
    }

    nodes.forEach(function (node) {
      node.nodeValue = node.nodeValue.replace(/\$[0-9]+(?:\.[0-9]{2})?/, paymentAmount);
    });
  }

  function updateVisiblePrice(section, variant) {
    if (!section || !variant || typeof variant.price === 'undefined') return;

    var priceEl = section.querySelector('[id^="ProductPrice-"]');
    if (!priceEl) return;

    priceEl.textContent = formatMoney(variant.price);
    priceEl.setAttribute('content', (Number(variant.price || 0) / 100).toFixed(2));
    updateAfterpayText(section, variant.price);
  }

  function bindInstantPrice(wrapper) {
    var section = findSection(wrapper);
    var select = wrapper && wrapper.querySelector('select');

    if (!section || !select || select.dataset.stickeredInstantPriceBound === 'true') return;
    select.dataset.stickeredInstantPriceBound = 'true';

    select.addEventListener('change', function () {
      updateVisiblePrice(section, findVariantForSelect(section, select));
    });

    updateVisiblePrice(section, findVariantForSelect(section, select));
  }

  function styleNativeSize(wrapper) {
    if (!wrapper) return;

    wrapper.classList.add('stk-native-banner-size');

    var label = wrapper.querySelector('label');
    var select = wrapper.querySelector('select');

    if (label) {
      label.textContent = 'Size';
      label.classList.add('stk-native-banner-size__label');
    }

    if (select) {
      select.classList.add('stk-native-banner-size__select');
    }
  }

  function moveNativeSize() {
    var slot = document.querySelector('[data-stk-native-banner-size-slot], .stk-native-banner-size-slot, #stk-native-banner-size-slot');
    if (!slot) return false;

    var section = findSection(slot);
    var wrapper = findNativeSizeWrapper(section);

    if (!wrapper) return false;
    if (slot.contains(wrapper)) {
      styleNativeSize(wrapper);
      bindInstantPrice(wrapper);
      return true;
    }

    styleNativeSize(wrapper);
    wrapper.dataset.stickeredNativeSizeMoved = 'true';
    slot.appendChild(wrapper);
    bindInstantPrice(wrapper);
    return true;
  }

  function init() {
    moveNativeSize();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

  var attempts = 0;
  var retryTimer = setInterval(function () {
    attempts += 1;

    if (moveNativeSize() || attempts >= 30) {
      clearInterval(retryTimer);
    }
  }, 300);
})();
